import React from 'react';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Card } from '@src/common/Card2';
import { CoreFeatures } from '@src/common/CoreFeatures';
import { usePPDLagoon } from '@sde/widgets-core/src/tools/lagoon';
import { ColumnHandler } from '../ColumnHandler';
import { styled } from '@uhg-abyss/web/tools/styled';

const StyledFlexContent = styled(Flex.Content, {
  padding: '15px 0px 0px 0px',
});

export const ToolLink = () => {
  const { getAdditionalToolsContentsBySection } = usePPDLagoon();
  const additionalTools = getAdditionalToolsContentsBySection();
  return (
    <React.Fragment>
      <For each='section' of={Object.keys(additionalTools)}>
        <StyledFlexContent space-100 key={section}>
          <CoreFeatures
            toggle={
              additionalTools[section].status ||
              additionalTools[section].showToggle
            }
          >
            <Card>
              <Card.Title>{additionalTools[section].title}</Card.Title>
              <Card.Body>
                <Flex gutters={[0, 0]}>
                  <ColumnHandler contents={additionalTools[section].contents} />
                </Flex>
              </Card.Body>
            </Card>
          </CoreFeatures>
        </StyledFlexContent>
      </For>
    </React.Fragment>
  );
};
